import {useQuery} from 'react-query'
import {MeetingsEditModalForm} from './MeetingsEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getMeetingsFilter} from '../core/_requests'
import { MeetingsStatus } from '../core/_models'

const MeetingsEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const {
    isLoading,
    data: category,
    error,
    status
  } = useQuery(
    `${QUERIES.CATEGORIES_LIST}-category-${itemIdForUpdate}`,
    () => {
      return getMeetingsFilter({id: itemIdForUpdate, take: 0, skip: 1})
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <MeetingsEditModalForm
        isMeetingsLoading={isLoading}
        response={{
          status_id: MeetingsStatus.active.id,
          created_at: new Date(),
        }}
        status={status}
      />
    )
  }

  if (!isLoading && !error && category) {
    return (
      <MeetingsEditModalForm
      isMeetingsLoading={isLoading}
        response={category?.data}
        status={status}
      />
    )
  }

  return null
}

export {MeetingsEditModalFormWrapper}
